import { Box, Card, Grid, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { VEHICLE } from "../../../../data/data";
import { useCallback, useEffect, useState } from "react";
import { ButtonComponent } from "../../../../components/form";

const CalculatorMobileVehicleFilter = ({selectedVehicleName, selectedBatta, setVehicle, setBatta, moveNextStep, backPrevStep, buttonLoading}) => {
    const theme = useTheme();

    const [selectedVehicle, setSelectedVehicle] = useState(-1);

    useEffect(() => {
        if(selectedVehicleName){
            for(let i = 0; VEHICLE.length; i++){
                if(VEHICLE[i].value === selectedVehicleName){
                    setSelectedVehicle(i);
                    break;
                }
            }
        }
    }, [selectedVehicleName]);

    const selectVehicle = useCallback((index, value) => {
        setSelectedVehicle(index);
        setVehicle(value);
    }, []);

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                spacing={3}
                pt={4}
            >
                {
                    VEHICLE.map((item, index) => {
                        return <Grid
                            key={index}
                            size="auto"
                        >
                            <IconButton
                                onClick={() => selectVehicle(index, item.value)}
                                sx={{
                                    p: 0
                                }}
                            >
                                <Card
                                    elevation={index === selectedVehicle ? 2 : 0}
                                    sx={{
                                        backgroundColor: index === selectedVehicle ? 'white' : 'rgba(239, 239, 240, 1)',
                                        width: '100px',
                                        height: '100px'
                                    }}
                                >
                                    <Stack
                                        direction='column'
                                        justifyContent='center'
                                        alignItems='center'
                                        sx={{
                                            height: '100%'
                                        }}
                                        spacing={1}
                                    >
                                        <Box
                                            sx={{
                                                width: '30px',
                                                height: '30px'
                                            }}
                                        >
                                            <img 
                                                src={index === selectedVehicle ? item.logoColor : item.logoColorless}
                                                alt={item.label}
                                                width='100%'
                                            />
                                        </Box>

                                        <Typography
                                            fontWeight={400}
                                            fontSize={14}
                                            letterSpacing={0.5}
                                            textAlign='center'
                                            px={2}
                                            color={index === selectedVehicle ? theme.palette.primary.main : 'rgba(128, 138, 147, 1)'}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Stack>
                                </Card>
                            </IconButton>
                        </Grid>
                    })
                }
            </Grid>

            {/* <SwitchComponent 
                standardLabel={`Batta`}
                checked={selectedBatta}
                onChange={(state) => {
                    setBatta(state);
                }}
            /> */}

            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                sx={{
                    py: 3,
                    width: '100%'
                }}
                spacing={1}
            >
                <ButtonComponent 
                    label='Next'
                    fullWidth
                    onClick={moveNextStep}
                    disabled={!selectedVehicleName}
                    inLoading={buttonLoading}
                />

               <ButtonComponent 
                    label='Back'
                    variant="text"
                    onClick={backPrevStep}
                    color='black'
                    disableRipple
                    sx={{
                        width: 'fit-content'
                    }}
                />
            </Stack>
        </>
    );
}

export default CalculatorMobileVehicleFilter;